import { FieldMap, FieldTypes, UpdateCallback } from '@hb/shared'

import { useFirebase } from '@chem-po/firebase-web'
import { PopUpMessageContext, ThemeContext, useApp } from '@hb/react'
import { useCallback, useContext } from 'react'
import { sendPasswordResetEmail } from '../../backend/auth/utils'
import { GenericEditModal } from '../DataView/GenericEditModal'
import { EditModalProps } from '../DataView/types'

const forgotPassword: FieldMap = {
  name: 'Forgot your password?',
  children: {
    email: {
      type: FieldTypes.EMAIL,
      labels: [{ text: "We'll send you a link to reset your password" }],
      placeholder: 'Email',
    },
  },
}

export const ForgotPasswordModal = (props: Omit<EditModalProps, 'field' | 'onSubmit'>) => {
  const { processResponse } = useContext(PopUpMessageContext)

  const { auth } = useFirebase()
  const { appName } = useApp()
  const handleSubmit = useCallback(
    async ({ email }: { email?: string }): Promise<UpdateCallback> => {
      if (!email) return { error: 'Email required' }
      return sendPasswordResetEmail(auth, { email, appName })
        .then(() =>
          processResponse({
            success: 'A password reset link has been sent to your email!',
          }),
        )
        .catch(err => {
          console.error(err)
          let error = 'Hmm, something went wrong'
          if (err.code === 'auth/user-not-found') {
            error = "We couldn't find that email address in our system"
          }
          return processResponse({
            error,
          })
        })
    },
    [processResponse, appName, auth],
  )

  return (
    <ThemeContext.Provider value={{ hideLabels: false, placeholderAbove: false }}>
      <GenericEditModal size="md" onSubmit={handleSubmit} field={forgotPassword} {...props} />
    </ThemeContext.Provider>
  )
}
